export const CUSTOMER_EXPERIENCE_CENTER_URL = 'https://community.imprivata.com/s/';

export const ROLE_TYPE_ADMIN = 'admin';

export const IMPRIVATA_DOMAIN = 'imprivata.id';

export enum productTags {
  PATIENT_ACCESS = 'patient-secure-identity',
}

export const PORTAL_IDLE_TIMEOUT = 15; // in minutes
export const SELF_SERVICE_TIMEOUT = 5; // in minutes
